<form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
  <mat-toolbar color="primary">
    <span>{{ "Rediger kommentar" | translate }}</span>
    <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <fieldset [formGroup]="skjema">
      <mat-form-field>
        <mat-label>{{ "Kommentar" | translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjema.controls.kommentar"/>
      </mat-form-field>
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()">{{ "Oppdater" | translate }}</button>
  </mat-dialog-actions>

</form>
